import { withBooking } from 'components/queries/GetBookingQuery';
import { withRouter } from 'react-router';

import ExchangeSeatSelection from './ExchangeSeatSelection.js';

export default withBooking(withRouter(ExchangeSeatSelection));
